
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PartnerWithUs/PA",
      function () {
        return require("private-next-pages/PartnerWithUs/PA.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PartnerWithUs/PA"])
      });
    }
  